(function($){
$(document).ready(function() {

    $(".formulaire-document").on("click", function(e) {
        e.preventDefault();
        const id = $(this).data("id");
        $titre = id == "" ? 'Ajout d\'un document' : 'Modification d\'un document';
        let params = {
            id: id
        }
        $.ajax({
            url: '/xhr-actions/formulaire_document',
            data: params,
            success : function(data) {
                $.popin.alert({
                    type: 'info',
                    title: $titre,
                    message: data,
                    button: 'fermer / annuler'
                });
            }
        });
    });

    $(".deployer-texte").on("click", function(e) {
        e.preventDefault();
        const id = $(this).attr("aria-controls");
        $(this).remove();
        $("#" + id).removeAttr('hidden');
    });

})
})(jQuery);

function annuler_recherche() {
    $.ajax({
        url: '/xhr-actions/annuler_recherche',
        success : function(data) {
            window.location.href=data;
        }
    });
}
